import * as requestFromServer from "./ordersCrud";
import { ordersSlice, callTypes } from "./ordersSlice";

const { actions } = ordersSlice;

export const fetchOrders = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findOrders(queryParams)
    .then((response) => {
      const { totalCount, entities } = response.data;
      dispatch(actions.ordersFetched({ totalCount, entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const createOrder = (orderForCreation) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return requestFromServer
    .createOrder(orderForCreation)
    .then((response) => {
      const order = response.data;
      dispatch(actions.orderCreated({ order }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};

export const getOpenOrder = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return requestFromServer
    .getOpenOrder()
    .then((response) => {
      const order = response.data;
      dispatch(actions.orderFetched({ order }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchOrder = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return requestFromServer
    .getOrderById(id)
    .then((response) => {
      const order = response.data;
      dispatch(actions.selectedOrderFetched({ order }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchOrderLogs = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return requestFromServer
    .getOrderLogs(id)
    .then((response) => {
      const logs = response.data;
      dispatch(actions.logsFetched(logs));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const finalizeOrder = (orderToFinalize) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return requestFromServer
    .finalizeOrder(orderToFinalize)
    .then(() => {
      dispatch(actions.orderFinalized());
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};

export const changeCategory = (id) => (dispatch) => {
  dispatch(actions.categoryChanged({ id }));
};

export const changeSearchText = (searchText) => (dispatch) => {
  dispatch(actions.searchChanged({ searchText }));
};

export const deleteOrder = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  requestFromServer
    .deleteOrder()
    .then(() => {
      dispatch(actions.orderFinalized());
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error;
    });
};

export const approveOrder = (orderId) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    
    requestFromServer
        .approveOrder(orderId)
        .then(() => {
            dispatch(actions.orderApproved());
        })
        .catch((error) => {
            dispatch(actions.catchError({ error, callType: callTypes.action }));
            throw error;
        });
    
}